// Generated file - do not change manually!

/**
 * Different types of ListItem.
 */
export enum ListItemType {
  /**
   * Indicates that the item is clickable via active feedback when item is pressed.
   */
  Active = 'Active',

  /**
   * Enables detail button of the list item that fires detail-click event.
   */
  Detail = 'Detail',

  /**
   * Indicates the list item does not have any active feedback when item is pressed.
   */
  Inactive = 'Inactive'
}
